if (!customElements.get('product-visibility')) {
  customElements.define('product-visibility', class ProductVisibility extends BaseElement
  {
    constructor ()
    {
      super();

      this.productCard = this.closest('product-card');
      this.donorCard = this.closest('.donor-card');
      this.update();

      this.addEventListener('click', e => {
        e.preventDefault();

        if (this.classList.contains('loading')) {
          return;
        }

        this.toggle();
      });

      this.onBroadcast('hiddenProducts', () => {
        this.update();
      });

      this.onBroadcast('hiddenProductLoadingStart', id => {
        if (id == this.getId()) {
          this.classList.add('loading');
        }
      });

      this.onBroadcast('hiddenProductLoadingEnd', id => {
        if (id == this.getId()) {
          this.classList.remove('loading');
        }
      });
    }

    update ()
    {
      if (this.classList.contains('loading')) {
        return;
      }

      if (this.isVisible()) {
        this.classList.remove('off');
        this.classList.add('on');

        if (this.productCard) {
          this.productCard.classList.remove('product-card-is-hidden');
        }
      } else {
        this.classList.remove('on');
        this.classList.add('off');

        if (this.productCard) {
          this.productCard.classList.add('product-card-is-hidden');
        }
      }
    }

    toggle ()
    {
      if (this.isVisible()) {
        this.hide();
      } else {
        this.show();
      }
    }

    hide ()
    {
      broadcast('hiddenProductLoadingStart', this.getId());

      this.classList.remove('on', 'off');

      if (this.productCard) {
        this.productCard.classList.add('product-card-is-hidden');
      }

      app.hidden.hide(this.getId(), err => {
        if (err) {
          this.classList.add('on');

          if (this.productCard) {
            this.productCard.classList.remove('product-card-is-hidden');
          }
        } else {
          this.classList.add('off');
        }

        broadcast('hiddenProductLoadingEnd', this.getId());
      });
    }

    show ()
    {
      broadcast('hiddenProductLoadingStart', this.getId());

      this.classList.remove('on', 'off');

      if (this.productCard) {
        this.productCard.classList.remove('product-card-is-hidden');
      }

      app.hidden.show(this.getId(), err => {
        if (err) {
          this.classList.add('off');

          if (this.productCard) {
            this.productCard.classList.add('product-card-is-hidden');
          }
        } else {
          this.classList.add('on');
        }

        broadcast('hiddenProductLoadingEnd', this.getId());
      });
    }

    getId ()
    {
      if (typeof(this.dataset.productId) !== 'undefined') {
        return this.dataset.productId;
      }

      if (this.productCard) {
        return typeof(this.productCard.dataset.productCardId) !== 'undefined'
          ? this.productCard.dataset.productCardId
          : null;
      }

      if (this.donorCard) {
        return typeof(this.donorCard.dataset.productId) !== 'undefined'
          ? this.donorCard.dataset.productId
          : null;
      }

      return null;
    }

    isVisible ()
    {
      return app.hidden.isVisible(this.getId());
    }
  });
}